module.exports = __webpack_public_path__ + "img/iphone-feature-bg-04.a09e81f0.svg";